var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"itemrow"},[_c('ul',{staticClass:"itemcontainer"},[_c('column-item',{attrs:{"info":_vm.item}}),_vm._v(" "),_c('column-suppliers',{attrs:{"info":_vm.item},on:{"select":_vm.selectedSupplier}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e318c7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/item-quote/components/list-items/ListItems.vue
// module id = null
// module chunks = 